import React, { Component } from 'react';
import CustomPhoneInput from 'components/CustomPhoneInput/CustomPhoneInput';

class AddNewNumberForm extends Component {
	state = {
		currentPhoneNumber: '',
		touched: false,
		isNumberValid: true,
		allowRenderForm: false,
	};

	componentDidMount() {
		const { innerFormState, setStateFromChild, currentPhoneNumber = '' } = this.props;
		if (innerFormState) {
			this.setState({
				...innerFormState,
			}, this.validateEmailInput);
		} else {
			this.setState({
				currentPhoneNumber: currentPhoneNumber || '',
				allowRenderForm: true,
			});
			setStateFromChild({
				innerFormState: {
					currentPhoneNumber: currentPhoneNumber || '',
					allowRenderForm: true,
				},
			});
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isSubmitTried !== this.props.isSubmitTried) {
			this.setState({
				isNumberValid: false,
			});
		}
	}

	handleOnChange = (value) => {
		const { handleOnChange, isValid, setStateFromChild, } = this.props;

		handleOnChange(value);
		const isNumberValid = isValid(value.replace(/\D/g, ''));

		this.setState({
			currentPhoneNumber: value,
			touched: true,
			isNumberValid,
		});

		setStateFromChild({
			isSubmitDisabled: !isNumberValid,
			innerFormState: {
				currentPhoneNumber: value,
				touched: true,
			},
		});
	};

	handleOnBlur = () => {
		const { currentPhoneNumber, touched } = this.state;
		if (touched) return;
		this.setState({
			touched: true,
		}, () => this.validateNumber(currentPhoneNumber));
	};

	validateNumber = (value) => {
		const { touched, } = this.state;
		const { isValid, } = this.props;
		const isNumberValid = isValid(value.replace(/\D/g, ''));
		const newIsNumberValid = touched ? isNumberValid : true;
		if (this.state.isNumberValid !== newIsNumberValid) {
			this.setState({
				isNumberValid: newIsNumberValid,
			});
		}
		return newIsNumberValid;
	};

	render() {
		const { currentPhoneNumber, isNumberValid, allowRenderForm } = this.state;

		return allowRenderForm && <CustomPhoneInput
			id="repPhoneNumber"
			value={currentPhoneNumber}
			helperText={'Phone number should be 10 digits'}
			handleOnChange={this.handleOnChange}
			handleOnBlur={this.handleOnBlur}
			error={!isNumberValid}
			isValid={this.validateNumber}
		/>
	}
}

export default AddNewNumberForm;